import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AdminContext = createContext();

export function AdminProvider({ children }) {
  const [token, setToken] = useState(() => sessionStorage.getItem('admin_token') || '');
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      axios.get(`${API}/admin/verify`, {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(() => setIsAdmin(true))
        .catch(() => { setToken(''); sessionStorage.removeItem('admin_token'); setIsAdmin(false); })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
      setIsAdmin(false);
    }
  }, [token]);

  const login = useCallback(async (password) => {
    const res = await axios.post(`${API}/admin/login`, { password });
    const t = res.data.token;
    sessionStorage.setItem('admin_token', t);
    setToken(t);
    setIsAdmin(true);
    return true;
  }, []);

  const logout = useCallback(() => {
    sessionStorage.removeItem('admin_token');
    setToken('');
    setIsAdmin(false);
  }, []);

  return (
    <AdminContext.Provider value={{ token, isAdmin, loading, login, logout }}>
      {children}
    </AdminContext.Provider>
  );
}

export function useAdmin() {
  const context = useContext(AdminContext);
  if (!context) throw new Error('useAdmin must be used within AdminProvider');
  return context;
}
